<div class="mt-md-3 container-fluid">

    <div class="row mt-2">
        <div>
            <div class="row mt-2">
                <div class="col-12  col-md-8 offset-md-2">
                    <h5 class=" text-secondary text-center">
                        <i class="  fas fa-user"></i> Compras financiadas
                    </h5>
                </div>
            </div>

            <ng-container>
                <div class="row" *ngIf="!loading">

                    <div>

                      <div class="flex flex-col md:flex-row justify-center mt-10 gap-4 px-4">
                        <!-- Selector de fechas -->
                        <div class="flex-1 max-w-md">
                          <input
                            style="padding: 16px 9px; background: white;"
                            id="demo-external"
                            (onSet)="birthdaySet()"
                            [(ngModel)]="range"
                            mbsc-range
                            class="form-control w-full"
                            [mbsc-options]="dateSetting3"
                            #externalRange="mobiscroll"
                          />
                        </div>

                        <!-- 💎 FILTRO MÚLTIPLE DE PRODUCTOS CON BÚSQUEDA DIRECTA -->
                        <div class="flex-1 max-w-md position-relative product-search-input">
                            <!-- Barra de Búsqueda Principal (estilo form-floating) -->
                            <div class="form-floating">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="productSearchInvoice"
                                    [(ngModel)]="productSearchTerm"
                                    (input)="filterProductsSearch()"
                                    (focus)="openDropdown()"
                                    (click)="openDropdown()"
                                    [readonly]="!showDropdown"
                                    placeholder="Buscar tipo de producto..."
                                    autocomplete="off">
                                <label for="productSearchInvoice">
                                    <i class="fas fa-search me-2"></i>
                                    Buscar tipo de producto
                                </label>
                                <!-- Botón limpiar (no mostrar si el producto es CREDIT) -->
                                <button
                                    type="button"
                                    class="btn btn-sm btn-outline-secondary position-absolute end-0 top-50 translate-middle-y me-2"
                                    *ngIf="productSearchTerm && selectedProducts[0] !== 'CREDIT'"
                                    (click)="clearProductSearch()"
                                    style="z-index: 10;">
                                    <i class="fas fa-times"></i>
                                </button>
                            </div>

                            <!-- Dropdown Elegante -->
                            <div
                                *ngIf="showDropdown"
                                class="dropdown-menu show position-absolute w-100 mt-2 shadow-lg border-0 filter-dropdown"
                                style="z-index: 1050;"
                            >
                                <!-- Header con contador -->
                                <div class="px-3 py-2 bg-light border-bottom">
                                    <div class="d-flex align-items-center justify-content-between">
                                        <small class="text-muted fw-medium">
                                            <i class="fas fa-list me-1 text-primary"></i>
                                            {{ filteredProductArray.length }} producto{{ filteredProductArray.length > 1 ? 's' : '' }} encontrado{{ filteredProductArray.length > 1 ? 's' : '' }}
                                        </small>
                                        <span class="badge bg-primary">{{ tempSelectedProducts.length }} seleccionado{{ tempSelectedProducts.length > 1 ? 's' : '' }}</span>
                                    </div>
                                </div>

                                <!-- Lista de Opciones -->
                                <div class="filter-options" style="max-height: 300px; overflow-y: auto;">

                                    <!-- Loading Skeleton -->
                                    <div *ngIf="filterStates.isLoadingProducts" class="p-3">
                                        <div *ngFor="let item of [1,2,3]" class="d-flex align-items-center mb-3">
                                            <div class="placeholder-glow flex-grow-1">
                                                <span class="placeholder col-8"></span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Opciones Reales -->
                                    <div *ngIf="!filterStates.isLoadingProducts">
                                        <div
                                            *ngFor="let item of filteredProductArray; trackBy: trackByProductCode"
                                            class="filter-option-item px-3 py-3 border-bottom cursor-pointer"
                                            [class.selected]="isProductSelected(item?.params?.code)"
                                            (click)="onProductSelectionChange(item?.params?.code, !isProductSelected(item?.params?.code))"
                                        >
                                            <div class="d-flex align-items-center">
                                                <!-- Icono -->
                                                <div class="me-3">
                                                    <i class="fas fa-cube text-primary"></i>
                                                </div>

                                                <!-- Texto -->
                                                <div class="flex-grow-1">
                                                    <div class="fw-medium text-dark">{{ item?.params?.name || item?.params?.code }}</div>
                                                    <small class="text-muted d-block">Código: {{ item?.params?.code }}</small>
                                                    <small class="text-muted d-block" *ngIf="item?.params?.dinamic_code && item?.params?.dinamic_code.length > 0">
                                                        Etiqueta: {{ item?.params?.dinamic_code[0] }}
                                                    </small>
                                                </div>

                                                <!-- Check de seleccionado -->
                                                <div *ngIf="isProductSelected(item?.params?.code)">
                                                    <i class="fas fa-check text-primary fa-lg"></i>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Mensaje cuando no hay resultados -->
                                        <div *ngIf="filteredProductArray.length === 0" class="text-center py-4">
                                            <i class="fas fa-search fa-3x text-muted mb-3"></i>
                                            <h6 class="text-muted">No se encontraron productos</h6>
                                            <p class="text-muted small">Intenta con otro término de búsqueda</p>
                                        </div>
                                    </div>
                                </div>

                                    <!-- Footer con Controles -->
                                    <div class="px-3 py-3 bg-light border-top">
                                        <!-- Info -->
                                        <div class="d-flex align-items-center justify-content-between mb-3">
                                            <small class="text-muted">
                                                <i class="fas fa-info-circle text-primary me-1"></i>
                                                {{ tempSelectedProducts.length }} de {{ productArray.length }} seleccionados
                                            </small>

                                            <!-- Botón Limpiar -->
                                            <button
                                                *ngIf="tempSelectedProducts.length > 1 || (tempSelectedProducts.length === 1 && tempSelectedProducts[0] !== 'CREDIT')"
                                                type="button"
                                                class="btn btn-sm btn-outline-secondary"
                                                (click)="clearAllFilters()"
                                            >
                                                <i class="fas fa-times me-1"></i>
                                                Limpiar
                                            </button>
                                        </div>

                                        <!-- Botones de Acción -->
                                        <div class="d-flex gap-2">
                                            <!-- Cancelar -->
                                            <button
                                                type="button"
                                                class="btn btn-outline-secondary flex-fill"
                                                (click)="closeDropdown()"
                                                [disabled]="filterStates.isApplyingFilter"
                                            >
                                                Cancelar
                                            </button>

                                            <!-- Aplicar -->
                                            <button
                                                type="button"
                                                class="btn btn-primary flex-fill"
                                                (click)="applyFilters()"
                                                [disabled]="filterStates.isApplyingFilter"
                                            >
                                                <span *ngIf="!filterStates.isApplyingFilter">
                                                    <i class="fas fa-check me-1"></i>
                                                    Aplicar
                                                </span>
                                                <span *ngIf="filterStates.isApplyingFilter">
                                                    <div class="spinner-border spinner-border-sm me-2" role="status"></div>
                                                    Aplicando...
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                            <!-- Estado de Error - Solo mostrar en casos críticos -->
                            <div *ngIf="filterStates.hasError && !stadistic" class="alert alert-warning mt-2" role="alert">
                                <div class="d-flex align-items-start">
                                    <i class="fas fa-exclamation-triangle me-2 mt-1"></i>
                                    <div class="flex-grow-1">
                                        <strong>Problema temporal</strong>
                                        <div class="small">{{ filterStates.errorMessage }}</div>
                                        <button
                                            type="button"
                                            class="btn btn-sm btn-outline-warning mt-2"
                                            (click)="retryOperation()"
                                        >
                                            <i class="fas fa-redo me-1"></i>
                                            Reintentar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>

                      <!-- Overlay de Carga para Estadísticas -->
                      <div *ngIf="filterStates.isApplyingFilter && !filterStates.isLoadingResults"
                           class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                           style="z-index: 1055; background: rgba(255,255,255,0.9);">
                          <div class="text-center">
                              <div class="spinner-border text-primary mb-3" role="status">
                                  <span class="visually-hidden">Cargando...</span>
                              </div>
                              <h5 class="text-primary">Aplicando filtros</h5>
                              <p class="text-muted mb-0">Obteniendo estadísticas...</p>
                          </div>
                      </div>

                        <section class="mt-16">
                          <div class="px-4 mx-auto max-w-screen-2xl lg:px-12">
                            <div class="relative overflow-hidden bg-white shadow-md dark:bg-gray-800 sm:rounded-lg">
                              <div class="px-4 divide-y dark:divide-gray-700">
                                <div class="flex flex-col items-start py-4 space-y-3 md:flex-row md:items-center md:space-y-0">

                                  <span class="text-xl font-bold mr-2">COMPRAS FINANCIADAS</span>
                                  <span>total({{shops.length}})</span>
                                  <div class="max-w-sm ml-5">
                                  </div>
                                </div>
                              </div>

                              <!-- Table -->
                              <div class="overflow-x-auto">
                                <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400 mb-3">
                                  <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                      <th scope="col" class="px-4 py-3">Tienda</th>
                                      <th scope="col" class="px-4 py-3">Pendiente</th>
                                      <th scope="col" class="px-4 py-3">Completado</th>
                                    </tr>
                                  </thead>


                                  <tbody (click)="setNavigationFlag()" [routerLink]="['/console/financial-payments/']" [queryParams]="{startDate: d1, endDate: d2}">
                                    <tr class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                                      <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                                        <span class="font-bold">TODAS LAS TIENDAS</span>
                                      </td>
                                      <td class="px-14 py-2 font-bold dark:text-white">
                                        <span>{{stadistic?.total?.pending || 0}}</span>
                                      </td>
                                      <td class="px-14 py-2 font-bold text-gray-900 dark:text-white">
                                        <span>{{stadistic?.total?.complete || 0}}</span>
                                      </td>
                                    </tr>
                                  </tbody>


                                  <tbody (click)="setNavigationFlag()" [routerLink]="['/console/financial-payments/',item.code]" [queryParams]="{startDate: d1, endDate: d2}" *ngFor="let item of shops; let i=index">
                                    <tr class="border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700">
                                      <td class="px-4 py-2 font-medium text-gray-900 dark:text-white">
                                        <span class="">{{item?.name}}</span>
                                      </td>
                                      <td class="px-14 py-2 font-medium text-gray-900 dark:text-white">
                                        <span>{{stadistic?.segment?.pending[item.code] || 0}}</span>
                                      </td>
                                      <td class="px-14 py-2 font-medium text-gray-900 dark:text-white">
                                        <span>{{stadistic?.segment?.complete[item.code] || 0}}</span>
                                      </td>
                                    </tr>
                                  </tbody>


                                </table>
                                <!-- <div class="min-h-[80px] flex items-center justify-center">
                                  <span class="text-gray-500 text-lg">Seleccione un producto</span>
                                </div> -->
                              </div>
                            </div>
                          </div>
                        </section>

                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="loading">
                <div class="w-100 text-center mt-2">
                    <img src="./assets/public/images/loading.gif" alt=" ">
                </div>
            </ng-container>

        </div>
    </div>
</div>
